import enDataVizTranslationsJson from './en_US.json'

export const enDataVizTranslations = enDataVizTranslationsJson
